<template>
  <a-card size="small" title="活跃度统计曲线" class="p-0">
    <div class="area-chart">
      <e-chart :options="options" autoresize />
    </div>
  </a-card>
</template>

<script>
export default {
  name: 'UserChart',
  props: {
    data: Array,
    opt: Object,
  },
  computed: {
    options () {
      const keys = this.data.map(item => this.$moment(item.record_at).format('YYYY-MM-DD'))
      keys.sort((a, b) => new Date(a).getTime() - new Date(b).getTime())
      const series = this.opt.lines.map(item => {
        return {
          name: item.label,
          type: 'line',
          data: [],
        }
      })
      keys.forEach(date => {
        const target = this.data.filter(item => this.$moment(item.record_at).format('YYYY-MM-DD') === date)
        if (target.length) {
          this.opt.lines.forEach((item, index) => {
            if (item.key === 'group_users') {
              series[index].data.push(target[0].group_users.reduce((acc, cur) => {
                return acc + cur
              }, 0))
            } else {
              series[index].data.push(target[0][item.key])
            }
          })
        }
      })
      return {
        grid: {
          left: '3%',
          right: '4%',
          bottom: '1%',
          containLabel: true,
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999',
            },
          },
        },
        // legend: {
        //   data: ['总活跃度', ...top3],
        // },
        xAxis: [
          {
            type: 'category',
            data: keys,
            axisPointer: {
              type: 'shadow',
            },
            axisLabel: {
              rotate: 45,
              interval: 0,
              // formatter: (val) => {
              //   return this.getName(val)
              // },
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
          },
        ],
        series,
      }
    },
  },
  methods: {
    getName (name) {
      return name.length > 15 ? name.slice(0, 15) + '...' : name
    },
  },
}
</script>

<style lang="less" scoped>
.area-chart {
  height: 350px;
  ::v-deep {
    .echarts {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
